import { useState } from 'react';
import CompareQuestion        from '../question_types/CompareQuestion';
import AddSubQuestion         from '../question_types/AddSubQuestion';
import FractionOfQuestion     from '../question_types/FractionOfQuestion';
import WordToFractionQuestion from '../question_types/WordToFractionQuestion';
import NumberLineQuestion     from '../question_types/NumberLineQuestion';
import FindXQuestion          from '../question_types/FindXQuestion';

const QUESTION_COMPONENTS = {
  compare:          CompareQuestion,
  addsub:           AddSubQuestion,
  fraction_of:      FractionOfQuestion,
  word_to_fraction: WordToFractionQuestion,
  number_line:      NumberLineQuestion,
  find_x:           FindXQuestion,
};

const TOPIC_NAMES = {
  1: 'Vienādu daļu salīdzinājumi',
  2: 'Saskaitīšana un atņemšana',
  3: 'Daļas no skaitļa',
  4: 'Daļu vārdi ciparu formātā',
  5: 'Daļa uz skaitļu taisnes',
  6: 'Atrast nezināmo skaitli',
};

function checkAnswer(question, userAnswer) {
  switch (question.type) {
    case 'compare':
      return userAnswer === question.correctAnswer;

    case 'addsub':
    case 'word_to_fraction': {
      const { num: cNum, den: cDen } = question.correctAnswer;
      const uNum = parseInt(userAnswer.num, 10);
      const uDen = parseInt(userAnswer.den, 10);
      if (isNaN(uNum) || isNaN(uDen) || uDen === 0) return false;
      return uNum * cDen === cNum * uDen;
    }

    case 'fraction_of':
    case 'find_x': {
      const parsed = parseInt(userAnswer, 10);
      if (isNaN(parsed)) return false;
      return parsed === question.correctAnswer;
    }

    case 'number_line': {
      return (
        userAnswer.num === question.correctAnswer.num &&
        userAnswer.den === question.correctAnswer.den
      );
    }

    default:
      return false;
  }
}

export default function QuizPage({ context, onFinish }) {
  const { topicId, questions } = context;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers]           = useState([]);
  const [feedback, setFeedback]         = useState(null); // null | 'correct' | 'wrong'

  const currentQuestion = questions[currentIndex];
  const QuestionComponent = QUESTION_COMPONENTS[currentQuestion.type];

  function handleAnswer(userAnswer) {
    if (feedback !== null) return; // prevent double-submit during feedback
    const isCorrect = checkAnswer(currentQuestion, userAnswer);
    const record = {
      questionId:    currentQuestion.id,
      userAnswer,
      correctAnswer: currentQuestion.correctAnswer,
      isCorrect,
    };
    const newAnswers = [...answers, record];
    setAnswers(newAnswers);
    setFeedback(isCorrect ? 'correct' : 'wrong');

    setTimeout(() => {
      setFeedback(null);
      if (currentIndex + 1 < questions.length) {
        setCurrentIndex(i => i + 1);
      } else {
        const score = newAnswers.filter(a => a.isCorrect).length;
        onFinish(topicId, score, questions.length, newAnswers);
      }
    }, 1200);
  }

  const progressPct = (currentIndex / questions.length) * 100;

  return (
    <div className="quiz-page">
      <div className="quiz-header">
        <div className="quiz-header-row">
          <span className="quiz-topic-name">{TOPIC_NAMES[topicId]}</span>
          <span className="progress-text">
            {currentIndex + 1} / {questions.length}
          </span>
        </div>
        <div className="progress-bar">
          <div
            className="progress-bar-fill"
            style={{ width: `${progressPct}%` }}
          />
        </div>
      </div>

      {feedback && (
        <div className={`feedback-banner feedback-${feedback}`}>
          {feedback === 'correct' ? 'Pareizi! ✓' : 'Nepareizi ✗'}
        </div>
      )}

      <QuestionComponent
        question={currentQuestion}
        onAnswer={handleAnswer}
        disabled={feedback !== null}
      />
    </div>
  );
}
